// components/CommentAddOrEditDialog.tsx

import { trpc } from '@web/lib/trpc';

import { Dialog, DialogContent } from '@web/components/ui/dialog';
import { DialogTitle } from '@radix-ui/react-dialog';
import { CommentAddOrEditForm } from './comment-add-or-edit-form';
import { CommentFormType } from '../-types/comment-form';

type EditCommentModalProps = {
  commentId: string;
  onClose: () => void;
};

export function CommentAddOrEditDialog({
  commentId,
  onClose,
}: Readonly<EditCommentModalProps>) {
  const utils = trpc.useUtils();

  const { data: commentDetails } = trpc.comment.getCommentDetails.useQuery({
    commentId,
  });

  const isDialogOpen = !!commentDetails;

  const { mutateAsync: updateComment } = trpc.comment.updateComment.useMutation(
    {
      onSuccess: async () => {
        await utils.comment.listAllCommentsOnRecord.invalidate();
        onClose();
      },

      onError: (error) => {
        if (error instanceof Error) {
          console.error('Error updating comment:', error.message);
        } else {
          console.error('An unknown error occurred while updating comment');
        }
      },
    },
  );

  const handleSubmit = async (data: CommentFormType) => {
    const { content } = data;

    await updateComment({ id: commentId, content });
  };

  return (
    <>
      <Dialog open={isDialogOpen} onOpenChange={onClose}>
        <DialogContent>
          <DialogTitle>Edit Comment</DialogTitle>

          {commentDetails && (
            <CommentAddOrEditForm
              comment={commentDetails}
              onClose={onClose}
              onSubmit={handleSubmit}
            />
          )}
        </DialogContent>
      </Dialog>
    </>
  );
}
